var _excluded = ["addOnTop", "logoPosition"];
var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/CaptiveWindow/CaptiveWindow.tsx",
  _this = this;
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Section } from '@wds/section';
import { Box } from '@wds/box';
import { LogoWithText } from '../Logos';
import Footer from './Footer';
import useStyles from './useStyles';
var CaptiveWindow = function CaptiveWindow(_ref) {
  var _ref$addOnTop = _ref.addOnTop,
    addOnTop = _ref$addOnTop === void 0 ? null : _ref$addOnTop,
    _ref$logoPosition = _ref.logoPosition,
    logoPosition = _ref$logoPosition === void 0 ? 'auto' : _ref$logoPosition,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles(),
    captiveWindowPage = _useStyles.captiveWindowPage,
    captiveWindowSection = _useStyles.captiveWindowSection,
    smLogoHeader = _useStyles.smLogoHeader,
    smLogoHeaderCenter = _useStyles.smLogoHeaderCenter,
    smLogoLogo = _useStyles.smLogoLogo;
  var headerClassName = [smLogoHeader, logoPosition === 'center' ? smLogoHeaderCenter : ''].join(' ');
  return /*#__PURE__*/React.createElement(Box, {
    className: captiveWindowPage,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Box, {
    className: captiveWindowSection,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("header", {
    className: headerClassName,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(LogoWithText, {
    className: smLogoLogo,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 11
    }
  })), addOnTop, /*#__PURE__*/React.createElement(Section, Object.assign({}, rest, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 9
    }
  }))), /*#__PURE__*/React.createElement(Box, {
    className: captiveWindowSection,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Footer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 9
    }
  })));
};
export default CaptiveWindow;
//# sourceMappingURL=CaptiveWindow.js.map